<template>
  <AnalyticsDecimalPrecisions />
  <AnalyticsTaxLots />
</template>

<script setup lang="ts">
import AnalyticsDecimalPrecisions from './AnalyticsDecimalPrecisions.vue'
import AnalyticsTaxLots from './AnalyticsTaxLots.vue'

defineOptions({ name: 'AnalyticsSettings' })
</script>
